/* eslint jsx-a11y/anchor-is-valid: "off" */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { CSSTransition, Transition } from 'react-transition-group';
import './menu.scss';

class Menu extends Component {
  static propTypes = {
    in: PropTypes.bool.isRequired,
    onClose: PropTypes.func
  };

  static defaultProps = {
    onClose: () => {}
  };

  constructor(props) {
    super(props);
    this.close = this.close.bind(this);

    this.routes = [
      <Link to="/works" onClick={this.close}>
        Work
      </Link>,
      <Link to="/about" onClick={this.close}>
        About
      </Link>,
      <Link to="/contact" onClick={this.close}>
        Contact
      </Link>
    ];
  }

  close() {
    this.props.onClose();
  }

  render() {
    return (
      <CSSTransition
        in={this.props.in}
        timeout={{
          enter: 100,
          exit: 75
        }}
        classNames="menu-fade"
        mountOnEnter
        unmountOnExit
      >
        <div className="menu-wrapper">
          <nav className="menu-nav">
            <ul>
              {this.routes.map((link, i) => {
                const delay = 50 * i;
                const duration = 150;
                const timeout = delay + duration;

                const defaultStyles = {
                  transitionProperty: 'opacity, transform',
                  transitionDuration: `${duration}ms, ${duration}ms`,
                  transitionTimingFunction: 'ease-in-out, ease-in-out',
                  transitionDelay: `${delay}ms, ${delay}ms`
                };

                const transitionStyles = {
                  entering: {
                    opacity: 0.01,
                    transform: 'translateY(20%)'
                  },
                  entered: {
                    opacity: 1,
                    transform: 'translateY(0)'
                  }
                };

                return (
                  <Transition key={`tr_${delay}`} in={this.props.in} appear exit={false} timeout={timeout}>
                    {state => (
                      <li
                        style={{
                          /* stylelint-disable */
                          ...defaultStyles,
                          ...transitionStyles[state]
                        }}
                      >
                        {link}
                      </li>
                    )}
                  </Transition>
                );
              })}
            </ul>
          </nav>
          <button className="menu-close" onClick={this.close}>
            <i className="fw-close" />
          </button>
        </div>
      </CSSTransition>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.jsx